import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { path } from 'ramda';

import { apiGetMembership, apiReviewMembership, apiDeleteMembershipRequest } from '../../../../api/membership';
import { toCurrency } from '../../../../util/helpers';
import { routes } from '../../../../routes';

import Card from '../../../../components/Card';
import FlaggedUserModal from '../../../../components/Modal/FlaggedUserModal';
import File from '../../../../components/File';
import ReviewModal from '../../../../components/Modal/ReviewModal';
import { handleSuccessBase, handleErrorBase } from '../../../../util/forms';

class Review extends Component {
  state = {
    membershipRequest: null,
    memberships: [],
    loaded: false,
    showApproveModal: false,
    showRejectModal: false,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedMembershipRequestId = match.params.id;

    apiGetMembership(selectedMembershipRequestId).then((resp) =>
      this.setState({ membershipRequest: resp.data, loaded: true }),
    );
  }

  hideModal = (finished) => {
    this.setState({ showApproveModal: false, showRejectModal: false }, () => {
      if (finished) {
        this.props.history.push(routes.admin.memberships.root);
      }
    });
  };

  renderField = (label, value) => (
    <p>
      <span className="font-weight-bold">{label}</span>: {value}
    </p>
  );

  render() {
    if (!this.state.loaded) return <noscript />;
    const { history } = this.props;
    const { membershipRequest, showApproveModal, showRejectModal } = this.state;
    const userName = `${path(['user', 'firstName'], membershipRequest)} ${path(
      ['user', 'lastName'],
      membershipRequest,
    )}`;

    return (
      <Fragment>
        {membershipRequest && (
          <FlaggedUserModal
            user={membershipRequest.user}
          >
          </FlaggedUserModal>
        )}
        <Card className="container">
          <Card.Header compact>
            Membership Request Approval
            <button
              className="btn btn-danger float-right"
              onClick={() =>
                apiDeleteMembershipRequest(membershipRequest.id)
                  .then(() => handleSuccessBase())
                  .then(() => history.push(routes.admin.memberships.root))
                  .catch((err) => {
                    console.error(err);
                    handleErrorBase('Could not delete membership');
                  })
              }
            >
              Delete
            </button>
          </Card.Header>
          <Card.Body>
            {this.renderField('User', userName)}
            {this.renderField('Membership', path(['membership', 'name'], membershipRequest))}
            {this.renderField('Price', toCurrency(path(['membership', 'price'], membershipRequest)))}
            {membershipRequest.media &&
              this.renderField(
                'Files',
                membershipRequest.media.map((file) => <File key={file.id} file={file} />),
              )}

            <div className="text-right">
              <button
                type="button"
                className="btn btn-danger mr-2"
                onClick={() => this.setState({ showRejectModal: true })}
              >
                Reject
              </button>

              <button
                type="button"
                className="btn btn-primary mr-2"
                onClick={() => this.setState({ showApproveModal: true })}
              >
                Approve
              </button>
            </div>
          </Card.Body>
        </Card>

        <ReviewModal
          id={membershipRequest.id}
          onHide={this.hideModal}
          showApproval={showApproveModal}
          showReject={showRejectModal}
          approvalMessage={() => (
            <p>
              Are you sure you want to grant this membership and charge{' '}
              {toCurrency(path(['membership', 'price'], membershipRequest))} to the user's card?
            </p>
          )}
          review={apiReviewMembership}
        />
      </Fragment>
    );
  }
}

export default withRouter(Review);
